import { 
  actions as coreActions,
  router5Reducer as coreReducer,
} from 'redux-router5'

import routerSelectors from '../selectors/router'

import {
  RouterState,
  ModuleReducer,
  ThunkHandler
} from '../../types/store'

import {
  RouterParams,
} from '../../types/router'

const navigateTo = coreActions.navigateTo

const setQueryParams: ThunkHandler<RouterParams, void> = (params = {}) => async (dispatch, getState) => {
  const route = routerSelectors.route(getState())
  if(!route) return
  dispatch(coreActions.navigateTo(route.name, params))
}

const mergeQueryParams: ThunkHandler<RouterParams, void> = (params = {}) => async (dispatch, getState) => {
  const route = routerSelectors.route(getState())
  if(!route) return
  const queryParams = routerSelectors.params(getState())
  const newParams = Object.assign({}, queryParams, params)
  dispatch(coreActions.navigateTo(route.name, newParams))
}

const removeQueryParams: ThunkHandler<string[], void> = (names) => async (dispatch, getState) => {
  const route = routerSelectors.route(getState())
  if(!route) return
  const queryParams = routerSelectors.params(getState())
  const newParams = Object
    .keys(queryParams)
    .reduce<RouterParams>((all, name) => {
      if(names.indexOf(name) < 0) {
        all[name] = queryParams[name]
      }
      return all
    }, {})
  dispatch(coreActions.navigateTo(route.name, newParams))
}

const clearQueryParams: ThunkHandler<void, void> = () => async (dispatch, getState) => {
  const route = routerSelectors.route(getState())
  if(!route) return
  dispatch(coreActions.navigateTo(route.name))
}

export const actions = {
  navigateTo,
  setQueryParams,
  mergeQueryParams,
  removeQueryParams,
  clearQueryParams,
}

const reducer = coreReducer as ModuleReducer<RouterState>

export {
  reducer
}

export default actions